import axios from 'axios'
import library from '../../../utils/Library'

export const verifyBasicVersionStatusMERegistration = async (
  organizationId
) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL = `${library.getBaseAPIUrl(
    'miestudio_user_registration'
  )}/verifyBasicVersionStatusMERegistration?organizationId=${organizationId}`

  return await axios({
    url: URL,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    }
  })
}
